<mat-dialog-content class="dialog-content">
  <section>
    <mds-grid
      [storageKey]="'scip-settings'"
      [minHeight]="'100%'"
      [overrides]="overrides"
      [sizeColumnsToFit]="true"
      [themeClass]="'ag-theme-material'"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)">
    </mds-grid>
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <mds-button
    (click)="createLegalEntity()"
    aria-label="Create" role="button" type="primary">Add New Legal Entity
  </mds-button>
</mat-dialog-actions>
